export function removeNotAlphanumericChars(value: string | undefined): string | undefined {
    return value?.replace(/\W/g, "");
}
